// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__E2o3z","container":"Footer_container__5LDql","linksContainer":"Footer_linksContainer__wa5ie","footer__link":"Footer_footer__link__67-ld"};